module.exports = __webpack_public_path__ + "img/logo-presidencia.afcdbd38.jpeg";